import { BaseService } from '../base';

export type PropertyType = {
  id: string;
  code: string;
  name: string;
  description: string;
};

export type PropertyTypesMeta = {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
};

export type PropertyTypesResponse = {
  data: PropertyType[];
  meta: PropertyTypesMeta;
};

export type GetPropertyTypesParams = {
  sortType?: 'ASC' | 'DESC';
  sortField?: string;
  pageSize?: number;
  pageNumber?: number;
};

export class PropertyTypesService extends BaseService {
  async getPropertyTypes(): Promise<{
    success: boolean;
    data?: PropertyTypesResponse;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/products/product-lines/homeowner/property-types?`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);

      return await this.handleJsonResponse<PropertyTypesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar tipos de imóvel',
      };
    }
  }
}

export const propertyTypesService = new PropertyTypesService();
